/** Product thumbnail flight, shared by product cards, product pages and sticky buttons. */
class FlyToCart extends HTMLElement {
  connectedCallback() {
    this.setAttribute('aria-hidden', 'true');
    if (!this.source || !this.destination || matchMedia('(prefers-reduced-motion: reduce)').matches) { this.remove(); return; }
    const a = this.source.getBoundingClientRect();
    const b = this.destination.getBoundingClientRect();
    const x = a.left + a.width / 2, y = Math.max(48, Math.min(innerHeight - 48, a.top + a.height / 2));
    const tx = b.left + b.width / 2, ty = Math.max(24, b.top + b.height / 2);
    Object.assign(this.style, {animation:'none', position:'fixed', left:'0', top:'0', width:'96px', height:'96px', zIndex:'2147483647', pointerEvents:'none', borderRadius:'16px', backgroundSize:'contain', backgroundRepeat:'no-repeat', backgroundPosition:'center', backgroundColor:'#fff', boxShadow:'0 8px 28px #0003', translate:'none', opacity:'1'});
    const transform = (px, py, scale) => `translate(${px - 48}px, ${py - 48}px) scale(${scale})`;
    const flight = this.animate([
      {transform:transform(x,y,1),opacity:1},
      {transform:transform(x+(tx-x)*.42,Math.min(y,ty)-60,.8),opacity:1,offset:.48},
      {transform:transform(tx,ty,.18),opacity:.25}
    ], {duration:850,easing:'cubic-bezier(.22,.61,.36,1)',fill:'forwards'});
    flight.finished.then(() => {
      if (this.destination.isConnected) this.destination.animate([{transform:'scale(1)'},{transform:'scale(1.18)'},{transform:'scale(1)'}],{duration:280});
    }).catch(() => {}).finally(() => this.remove());
  }
}
if (!customElements.get('fly-to-cart')) customElements.define('fly-to-cart', FlyToCart);
